<template>

	<div>

		<!-- <div class="masthead" :style="{backgroundImage: 'url('+mastheadBackgroundImage+')'}">
			<h1><slot name="headline" /></h1>
			<slot name="mastHeadVideo" />
		</div> -->

		<div class="masthead">
			<BackgroundVideo :src="mastheadBackground" class="masthead__video" />
			<div class="masthead__body">
				<div class="product"><slot name="preHeadline" /></div>
				<h1><slot name="headline" /></h1>
			</div>
		</div>

		<div class="section-nav">
			<slot name="nav" />
		</div>

		<div class="body">
			<slot name="body" />
		</div>

		<div class="footer">
			<slot name="footer" />
		</div>

	</div>

</template>

<script>

	import BackgroundVideo from '@/components/VideoServerBackgroundVideo'

	export default {
		name: "layout",
		props: {
			mastheadBackground: String
		},
		components: { BackgroundVideo },
		data () {
			return {
				loaded: false
			}
		}
	}

</script>

<style lang="scss" scoped>
	@import "list-style-reset.scss";
	@import "button-reset.scss";
	@import "media.scss";
	@import "responsive-font.scss";
	@import "container.scss";

	section {
		padding:5vw 0;
		&.slim {
			padding:0;
		}
	}

	.masthead {
		@include container;
		overflow:hidden; position:relative; background:#000000;
		@include media(small, large) {
			padding-top:10rem; padding-bottom:3rem;
		}
		@include media(large) {
			height:75vh; padding-top:28vh;
		}
		h1 {
			@include responsive-font(35);
			line-height:1.16; font-weight:400; color:#ffffff; text-transform:uppercase;
			@include media(large) {
				@include responsive-font(50);
			}
		}

		&:before {
			position:absolute; top:0; right:0; left:0; bottom:0; background-color:rgba(#000, .3); z-index:2; content:'';
		}

		&__video {
			max-width:100%; max-height:100%; min-width:100%; min-height:100%; object-fit:cover; position:absolute; top:0; left:0; z-index:1;
			@include media(small, large) {
				max-width:100%;
			}
		}

		&__body {
			position:relative; z-index:3;
			@include media(small, large) {
				text-align:center;
			}
			@include media(large) {
				max-width:60vw;
			}
		}
	}

	.product {
		@include responsive-font(20);
		font-family:"Oswald"; text-transform:uppercase; font-weight:400; color:#fff; line-height:1; margin-bottom:.25em;
		mark {
			color:#FDB913;
		}
	}

	.body {
		section:nth-of-type(even),
		section.dark {
			background:#F6F8F9;
		}
		section.light {
			background::#fff;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Products/layout.vue